import Certificate from './components';

export default Certificate;
